module.exports = "/_next/static/fonts/founders-grotesk-web-regular-17b12cca20616629d89f43c718256389.woff2";